if (!window.location.pathname.includes('/products/')) {
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const submitButton = form.querySelector('button[type="submit"]');
      const buttonTextSpan = submitButton.querySelector('span');
      const originalText = buttonTextSpan?.textContent?.trim() || 'Add to cart';
      const variantId = form.querySelector('input[name="id"]')?.value;

      if (!variantId) {
        console.error('Variant ID missing in form.');
        return;
      }

      // Show spinner
      const spinner = form.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      submitButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `id=${variantId}&quantity=1`
      })
      .then(response => {
        if (!response.ok) throw new Error('Network error');
        return response.json();
      })
      .then(data => {
        console.log('Added to cart:', data);

        // Update only the text inside the <span>
        if (buttonTextSpan) buttonTextSpan.textContent = 'Added ✅';
        submitButton.classList.add('added-success');

        setTimeout(() => {
          if (buttonTextSpan) buttonTextSpan.textContent = originalText;
          submitButton.disabled = false;
          submitButton.classList.remove('added-success');
        }, 2000);
      })
      .catch(error => {
        console.error('Add to cart failed:', error);
        submitButton.disabled = false;
      })
      .finally(() => {
        if (spinner) spinner.classList.add('hidden');
      });
    });
  });
}
